import { Link } from 'react-router-dom';
import Header from '../../components/layout/header.component';
import Asaid from '../../components/layout/asaid.component';
import Footer from '../../components/layout/footer.component';
import useBgPages from '../../hooks/use-bg-pages.hook';
import { LandingRouteService } from '../../services/landing-route.service';

function NotFoundPage() {
  useBgPages();
  const homeRoute = LandingRouteService.getHomeRoute();

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div
            className="content fs-6 d-flex flex-column flex-column-fluid bg-cards-p"
            id="kt_content"
          >
            <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
              <div className="d-flex flex-column flex-lg-row-fluid align-items-center justify-content-center py-10 bg-p-sdark">
                <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between p-5">
                  <div className="col-lg-6 text-center text-lg-start">
                    <h1 className="text-info fw-bolder mb-3 fs-6x animated-Alert">404</h1>
                    <h1 className="fw-bolder mb-3 fs-3x inputb text-dark">Página no encontrada</h1>
                    <p className="text-gray-500 fs-2 mb-10 inputb">
                      Lamentamos informarte que la página que estás buscando no existe o ha sido
                      removida.
                    </p>
                    <Link className="btn btn-primary btn-lg rounded inputb" to={homeRoute}>
                      Regresar
                    </Link>
                  </div>
                  <div className="col-lg-6 d-flex justify-content-center">
                    <img
                      src="/assets/media/illustrations/undraw/notify-2.svg"
                      alt="Link caducado o no exite la url"
                      className="img-fluid mb-20 link-caducated"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default NotFoundPage;
